module.exports = __webpack_public_path__ + "img/bg3@2x.794745ca.jpg";